export enum ShootingType {
  'DIRECT' = 'DIRECT',
  'AGENT' = 'AGENT',
  'PARTNER' = 'PARTNER',
}

export enum ShootingStatus {
  BOOKED = 'BOOKED',
  REVIEWED = 'REVIEWED',
  DELIVERED = 'DELIVERED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  NOT_EXECUTED = 'NOT_EXECUTED',
  CLOSED = 'CLOSED',
}

export enum VirtualTourType {
  MATTERPORT = 'MATTERPORT',
  FLOORFY = 'FLOORFY',
}

export enum EnhancementPipelineStatus {
  NOT_STARTED = 'NOT_STARTED',
  PROCESSING = 'PROCESSING',
  PARTIAL_ERROR = 'PARTIAL_ERROR',
  ERROR = 'ERROR',
  END = 'END',
}

export enum ShootingFileStatus {
  UPLOADING = 'UPLOADING',
  UPLOAD_ERROR = 'UPLOAD_ERROR',
  UPLOADED = 'UPLOADED',
  PROCESSING = 'PROCESSING',
  END = 'END',
  ERROR = 'ERROR',
}
